import { render, staticRenderFns } from "./NewAccountForm.vue?vue&type=template&id=387d83ce"
import script from "./NewAccountForm.vue?vue&type=script&lang=js"
export * from "./NewAccountForm.vue?vue&type=script&lang=js"
import style0 from "./NewAccountForm.vue?vue&type=style&index=0&id=387d83ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports